<template>
  <div  >
    <Header></Header>
    <div v-if="list.length==0" style="margin-top:100px" >
        <img src="../../assets/paper/notest.png" alt="">
    </div>
    <div v-if="list.length!=0">
      <Title title="考试列表"></Title>
      <div class="contain_main">
        <div class="search">
          <div class="search_item" @keydown.enter="changepage(1)"> 
            <div class="item">
              <span>考试名称:</span>
              <Input v-model="data.examtitle" placeholder="请输入..." style="width:2rem"/>
            </div>
            <!-- <div class="item">
              <span>考试状态:</span>
              <Select v-model="data.status" style="width:2rem">
                <Option value="1">未开始</Option>
                <Option value="2">进行中</Option>
                <Option value="3">已结束</Option>
                <Option :value="' '">全部</Option>
              </Select>
            </div> -->
            <div class="item">
              <div @click="changepage(1)" class="button">搜索</div>
            </div>
          </div>
        </div>
        <div class="table">
          <table>
            <thead>
              <tr>
                <td>考试编号</td>
                <td>考试名称</td>
                <td>考试开始时间</td>
                <td>考试结束时间</td>
                <!-- <td>考试状态</td> -->
                <td>题量</td>
                <td>满分</td>
                <td>操作</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in list" :key="'testlist'+index">
                <td>{{item.examid}}</td>
                <td>
                  <Tooltip :content="item.examtitle" placement="top-start">
                    <span class="tableName">{{item.examtitle}}</span>
                  </Tooltip>
                </td>
                <td>{{item.examstartime|formatetime}}</td>
                <td>{{item.examendtime|formatetime}}</td>
                <!-- <td>{{item.examendtime|timedesc}}</td> -->
                <td>{{item.epcount}}</td>
                <td>{{item.epscore}}</td>
                <td>
                  <button @click="todetail(item.examid)">查看详情</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div  style="text-align:right;margin-top:20px;">
          <Page :current='data.page' :total="total" @on-change="changepage" @on-page-size-change="changesize"  show-sizer show-elevator   show-total   :page-size-opts="[5,10, 20,50]"/>
        </div>
      </div>
      <div style="height:100px"></div>
    </div>
  </div>
</template>
<script>
import { Exam_index } from "../../assets/js/api.js";
import Header from "../../components/header";
import Title from "../../components/title";
import fun from "../../assets/js/fun.js"
export default {
  name: "testlist",
  data() {
    return {
      list: [],
      data: {
        examtitle: "", //	string	true	普通参数		考试名称
        status: " ", //	string	true	普通参数		1未开始2考试中3已结束
        examdecide: "", //	string	true	普通参数		0需约卷1无需阅卷
        page: 1, //	string	true	普通参数		页码
        size: 10 //	string	true	普通参数		条数
      }
    };
  },
  mounted() {
    this.getlist();
  },
  filters:{
    timedesc(value){
      if(value){
        var date = new Date()
        if(Number(value)>(date.getTime()/1000)){
          return "进行中"
        }else{
          return "已结束"
        }
      }else{
       return "进行中"
      }
    }
  },
  components: {
    Header,
    Title
  },
  methods: {
    // formate(data){
    //     return fun.formatetime(data)
    // },
    changepage(data){
        this.data.page=data;
        this.getlist()
    },
    changesize(data){
        this.data.page=1;
        this.data.size=data
        this.getlist()
    },
    getlist() {
      Exam_index(this.data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.total = res.data.data.count
          return
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    },
    todetail(data){
      this.$router.push({path:'/attention',query:{id:data}})
    }
  }
};
</script>
<style lang="css" scoped>
/* 搜索栏样式------------------------------------------------------------------------------------------- */
.search {
  margin-top: 0.2rem;
  display: flex;
  color: #575e6b;
}
.search .search_item {
  display: flex;
}
.search .search_item .item {
  margin: 0 0.15rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
/* 表格栏目样式----------------------------------------------------------------------------------------------*/
.table {
  margin-top: 0.6rem;
  font-size: 0.14rem;
}
table {
  width: 100%;
}
thead tr {
  color: #a4acbf;
}
tbody tr {
  color: #707788;
}
tr {
  height: 0.6rem;
}
/*查看详情button-----------------------------------------------------------------------------------------------------------------*/
button {
  color: #25b3f9;
  background: #d3f3fc;
  border-radius: 0.5rem;
  border: none;
  padding: 0.04rem 0.1rem;
  font-size: 0.14rem;
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/testlists/testlist.vue